<template>
    <TopNav></TopNav>
    <h1>Markup Calculator</h1>
    <fieldset>
        <legend>Markup Calculator</legend>
        <label for="co" class="leftLabel">Cost:</label> <input type="number" v-model.number="cost" step="any" @input="onCostChange" autofocus id="co"> <label for="co">$</label>
        <br>
        <label for="ma" class="leftLabel">Markup:</label> <input type="number" v-model.number="markup" step="any" @input="onMarkupChange" id="cu"> <label for="ma">%</label>
        <br>
        <label for="re" class="leftLabel">Revenue:</label> <input type="number" v-model.number="revenue" step="any" @input="onRevenueChange" id="re"> <label for="re">$</label>
        <br>
        <label for="pr" class="leftLabel">Profit:</label> <input type="number" v-model.number="profit" step="any" @input="onProfitChange" id="pr"> <label for="pr">$</label>
    </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
    name: "Markup",
    data() {
        return {
            cost: 100,
            markup: 10,
            revenue: 110,
            profit: 10,
        }
    },
    components: {
        TopNav
    },
    methods: {
        onCostChange(e) {
            const costPrice = e.currentTarget.value;
            const costNumber = Number(costPrice);
            this.revenue = costNumber + ((costNumber * this.markup) / 100.00);
            this.profit = (costNumber * this.markup) / 100.00;
        },
        onMarkupChange(e) {
            const markupPercentage = e.currentTarget.value;
            const markupPercentageNumber = Number(markupPercentage);
            this.revenue = this.cost + ((this.cost * markupPercentageNumber) / 100.00);
            this.profit = (this.cost * markupPercentage) / 100.00;
        },
        onRevenueChange(e) {
            const revenuePrice = e.currentTarget.value;
            const revenuePriceNumber = Number(revenuePrice);
            this.profit = revenuePriceNumber - this.cost;
            this.markup = 100 * (revenuePriceNumber - this.cost) / this.cost;
        },
        onProfitChange(e) {
            const profitPrice = e.currentTarget.value;
            const profitPriceNumber = Number(profitPrice);
            this.revenue = this.cost + profitPriceNumber;
            this.markup = (100 * profitPriceNumber) / this.cost;
        }
    },
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

body {
    margin: 1em auto;
    margin-top: 0;
    max-width: 40em;
    font-family: Arial, Helvetica, sans-serif;
}

label.leftLabel {
    display: inline-block;
    min-width: 155px;
}

input[type=number] {
    width: 100px;
}

footer section a {
    margin: 20px;
}
</style>
